import isCypress from '../helpers/isCypress';
import { HOST_PATHS } from './alertsConfig';
var NODE_ENV = import.meta.env.NODE_ENV;
var FEATURE_FLAG_PROD_URL = 'https://images.synchronycredit.com/serviceFiles/json/alerts/alerts-prod-config.json';
var FEATURE_FLAG_LOWER_ENV_URL = 'https://images.synchronycredit.com/serviceFiles/json/alerts/alerts-nonprod-config.json';
export var targetOrigin = "https://".concat(window.location.host);
var mockOrigin = isCypress()
    ? 'https://alerts-wiremock.app.dev.use1.pcf.syfbank.com/api'
    : "".concat(window.location.protocol, "//").concat(window.location.host);
var isLowerEnv = window.location.hostname.indexOf('dev') !== -1 ||
    window.location.hostname.indexOf('qa') !== -1 ||
    window.location.hostname.indexOf('uat') !== -1;
var defaultConfig = {
    ASSET_HOST: "https://".concat(window.location.host),
    NODE_ENV: NODE_ENV,
    MOCK_DATA_ENABLED: isLowerEnv,
    MOCK_DATA_HOST: mockOrigin,
    FEATURE_FLAG_SERVICE_URL: isLowerEnv
        ? FEATURE_FLAG_LOWER_ENV_URL
        : FEATURE_FLAG_PROD_URL
};
var localConfig = {
    ASSET_HOST: HOST_PATHS.LOCAL,
    BASENAME: "/",
    NODE_ENV: NODE_ENV,
    MOCK_DATA_ENABLED: true,
    MOCK_DATA_HOST: mockOrigin,
    FEATURE_FLAG_SERVICE_URL: FEATURE_FLAG_LOWER_ENV_URL
};
export default NODE_ENV === 'production' ? defaultConfig : localConfig;
